import * as types from 'actions/types';
import * as extract from 'extractFromState';
import * as triggers from 'constants/commerceTriggers';
import * as actions from 'actions/index';
import * as listTypes from 'constants/infoPanelTypes';
import { getReadableDetectionSource } from 'util/commerceUtil';
import { DraftHelpers } from 'util/Draft';
import isEmpty from 'lodash/isEmpty';
import { showError } from 'util/errorPopupUtil';
import { isLiveChat } from 'util/chat';

export const setCommerceWizardPath = (path) => ({
  type: types.SET_COMMERCE_WIZARD_PATH,
  path,
});

export const setCommerceWizardSelectedProduct = (selectedRecommendation) => ({
  type: types.SET_COMMERCE_WIZARD_SELECTED_RECOMMENDATION,
  selectedRecommendation,
});

export const setCommerceWizardPreviousRecommendation = (selectedPreviousRecommendation) => ({
  type: types.SET_COMMERCE_WIZARD_PREVIOUS_RECOMMENDATION,
  selectedPreviousRecommendation,
});

export const clearCommerceWizardState = () => (dispatch) => {
  dispatch(setCommerceWizardPath([]));
  dispatch(setCommerceWizardSelectedProduct(null));
  dispatch(setCommerceWizardPreviousRecommendation(null));
};

export const eraseRecommendationRegExFromTextInput =
  (forcedTicketId = null) =>
  (dispatch, getState) => {
    const state = getState();
    const centerPanelistType = extract.extractInfoPanelListTypeFromState(state);
    const infoPanelActive = extract.extractCenterPaneInfoPanelActiveFromState(state);
    const commerceWizardActive = infoPanelActive && centerPanelistType === listTypes.COMMERCE ? true : false;
    if (commerceWizardActive || forcedTicketId) {
      const editorState = extract.getNewMessagesEditor(state);
      const selectedConversationId = forcedTicketId || extract.extractNonHistoricalTicketIdFromState(state);
      let editorStateWithRegExRemoved = DraftHelpers.replaceRegularExpression(
        '',
        editorState,
        triggers.RECOMMEND_A_PRODUCT_TRIGGER,
        true
      );
      dispatch(actions.saveNewMessageEditorState(selectedConversationId, editorStateWithRegExRemoved));
    }
  };

export const trackCommerceCloseWithNoRecommendations = () => (dispatch, getState) => {
  try {
    const state = getState();
    const selectedTicket = extract.extractSelectedTicketFromState(state);
    const productDetected = extract.extractCommerceWizardProductDetected(state);
    const detectionSource = extract.extractCommerceWizardDetectionSource(state);
    const crossSell = extract.extractCommerceWizardCrossSellProducts(state).slice(0, 3);
    const upSell = extract.extractCommerceWizardUpsSellProducts(state).slice(0, 3);
    const global = extract.extractCommerceWizardGlobalProduct(state).slice(0, 3);

    let note = 'Expert viewed and closed product recommendations without making a suggestion to the customer.\n\n';
    if (productDetected) {
      const link = productDetected.productLink;
      note += `DETECTED PRODUCT: ${productDetected.title} ${link}\nDETECTION SOURCE: ${getReadableDetectionSource(
        detectionSource
      )}\n\n`;
    }

    if (!isEmpty(crossSell)) {
      note += `Rejected additional product suggestions:\n`;
      crossSell.forEach((recommendation) => {
        const link = recommendation.productLink;
        note += `- ${recommendation.title} ${link}\n`;
      });
      note += `\n\n`;
    }

    if (!isEmpty(upSell)) {
      note += `Rejected alternative product suggestions:\n`;
      upSell.forEach((recommendation) => {
        const link = recommendation.productLink;
        note += `- ${recommendation.title} ${link}\n`;
      });
      note += `\n\n`;
    }

    if (!isEmpty(global)) {
      note += `Rejected global product suggestions:\n`;
      global.forEach((recommendation) => {
        const link = recommendation.productLink;
        note += `- ${recommendation.title} ${link}\n`;
      });
      note += `\n\n`;
    }
    // If the ticket is a chat ticket, we are currently NOT leaving notes if the specialist choosed not to use a recommendation since they are not blocking/mandatory on chat as of now
    if (!isLiveChat(selectedTicket.communicationType)) {
      dispatch(actions.addNoteToSelectedTicket(note));
    }
  } catch (err) {
    showError(err);
  }
};
